import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import {
  assignRefferelsOnTestConfirm,
  getAllBookedTests,
  getAllRefferelsOnTestById,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../Services/api";

const Testbooking = () => {
  const token = useSelector((state) => state.user.token);

  const [orders, setorders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [selectedService, setSelectedService] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showReferModal, setShowReferModal] = useState(false);

  // Referral data source/API has not been supplied yet.
  const [referrals, setReferrals] = useState([]);
  const [selectedReferrals, setSelectedReferrals] = useState([]);
  const [referralConfirmed, setReferralConfirmed] = useState(false);
  const [referralCommissions, setReferralCommissions] = useState({});

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentServices = Object.values(orders || {}).slice(
    indexOfFirst,
    indexOfLast,
  );

  const totalPages = Math.ceil(
    Object.values(orders || {}).length / itemsPerPage,
  );

  const handleGetTestOrders = async () => {
    try {
      const res = await getAllBookedTests(token);
      console.log("getAllBookedTests", res);

      if (res.status === 200) {
        setorders(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dumy = async () => {
    try {
      const res = await api.get(
        "http://192.168.29.251:9998/adminweb/patient/invoice/by-number/113",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("dummy", res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetTestOrders();
    dumy();
  }, []);

  const openViewModal = (service) => {
    setSelectedService(service);
    setShowViewModal(true);
  };

  const openReferModal = (service) => {
    setSelectedService(service);
    handleGetRefferelsofTestById(service);
    setSelectedReferrals([]);
    setReferralConfirmed(false);
    setShowReferModal(true);
  };

  const handleGetRefferelsofTestById = async (service) => {
    try {
      console.log(service, service[0]?.bill?.id);

      const res = await getAllRefferelsOnTestById(token, service[0]?.bill?.id);
      console.log(res);
      if (res.status === 200) {
        setReferrals(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

const handleConfirmReferral = async() => {
  if (selectedReferrals.length === 0) {
    toast.error("Please select at least one referral");
    return;
  }

  const missingCommission = selectedReferrals.some((referral) => {
    const commission = referralCommissions[referral.id];

    return (
      commission?.commissionRate === undefined ||
      commission?.commissionRate === "" ||
      commission?.commissionAmount === undefined ||
      commission?.commissionAmount === ""
    );
  });

  if (missingCommission) {
    toast.error("Please enter commission rate and amount for every selected referral");
    return;
  }
  console.log(patient);
  

  const data = {
    patientId: patient?.patientId,
    referrals: selectedReferrals.map((referral) => {
      const commission = referralCommissions[referral.id];

      return {
        referredByCommonUserId: referral.referralCommonUserId,
        referenceType: "SERVICE",
        productId: null,
        serviceId: referral.serviceId ?? null,
        customizeRequestId: null,
        checkoutId: null,
        storeSellId: null,
        patientServiceId: referral.services?.[0]?.patientServiceId ?? null,
        referredCategoryId: referral.referralCategoryId ?? null,
        commissionRate: Number(commission.commissionRate),
        commissionAmount: Number(commission.commissionAmount),
        remarks: "Employee referral",
      };
    }),
  };

  console.log("Referral Payload:", data);

  setReferralConfirmed(true);
  try {
      const res= await assignRefferelsOnTestConfirm(token,data)
  console.log(res);
  if(res.status===200){
    toast.success("Referrals confirmation successful")
    setShowReferModal(false)
    
  }
  } catch (error) {
    console.log(error);
    
  }

  
};

  const patient = selectedService?.[0];

  return (
    <div id="main_content" className="tb-page">
      <Header />

      <div className="page">
        <Section />

        <div className="tb-container">
          {/* Page heading */}
          <div className="tb-page-heading">
            <div>
              <div className="tb-eyebrow">HEALTHCARE MANAGEMENT</div>
              <h1>Test Bookings</h1>
              <p>
                Manage booked tests, patient details and referral information.
              </p>

              <div className="tb-breadcrumb">
                <span>RNDSAN</span>
                <span className="tb-breadcrumb-separator">/</span>
                <span className="tb-breadcrumb-current">Test Bookings</span>
              </div>
            </div>

            <div className="tb-heading-stat">
              <div className="tb-heading-stat-icon">
                <i className="fa fa-flask" />
              </div>
              <div>
                <strong>{Object.values(orders || {}).length}</strong>
                <span>Total Bookings</span>
              </div>
            </div>
          </div>

          {/* Table section */}
          <div className="tb-table-card">
            <div className="tb-table-card-header">
              <div>
                <h3>All Test Bookings</h3>
                <p>Patient booking records and assigned service details.</p>
              </div>

              <div className="tb-record-count">
                <span className="tb-record-dot"></span>
                {Object.values(orders || {}).length} Records
              </div>
            </div>

            <div className="tb-table-responsive">
              <table className="tb-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Patient Name</th>
                    <th>Phone</th>
                    <th>Test</th>
                    <th>Service Person</th>
                    <th>Audiometer</th>
                    <th>Billing</th>
                    <th className="tb-action-heading">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {currentServices.map((service, ind) => {
                    const booking = service?.[0];

                    return (
                      <tr key={booking?.id || indexOfFirst + ind}>
                        <td>
                          <span className="tb-id">
                            #{indexOfFirst + ind + 1}
                          </span>
                        </td>

                        <td>
                          <div className="tb-patient-cell">
                            <div className="tb-patient-avatar">
                              {booking?.patientName?.charAt(0) || "P"}
                            </div>
                            <span>{booking?.patientName || "—"}</span>
                          </div>
                        </td>

                        <td>
                          <span className="tb-phone">
                            <i className="fa fa-phone" />
                            {booking?.patientPhone || "—"}
                          </span>
                        </td>

                        <td>
                          <span className="tb-test-name">
                            {booking?.serviceName || "—"}
                          </span>
                        </td>

                        <td>
                          {booking?.servicePerson ? (
                            <div className="tb-person-cell">
                              <span className="tb-person-avatar">
                                {booking?.servicePerson?.firstName?.charAt(0) ||
                                  "S"}
                              </span>
                              <span>
                                {booking?.servicePerson?.firstName}{" "}
                                {booking?.servicePerson?.lastName}
                              </span>
                            </div>
                          ) : (
                            <span className="tb-muted">Not assigned</span>
                          )}
                        </td>

                        <td>
                          <div className="tb-audiometer">
                            <strong>
                              {booking?.audiometer?.companyName || "—"}
                            </strong>
                            <small>
                              {booking?.audiometer?.model || ""}
                              {booking?.audiometer?.acHeadPhone
                                ? ` (${booking.audiometer.acHeadPhone})`
                                : ""}
                            </small>
                          </div>
                        </td>

                        <td>
                          <span className="tb-billing">
                            ₹{booking?.bill?.grandTotalAmount ?? "—"}
                          </span>
                        </td>

                        <td>
                          <div className="tb-actions">
                            <button
                              type="button"
                              className="tb-view-btn"
                              title="View booking details"
                              onClick={() => openViewModal(service)}
                            >
                              <i className="fa fa-eye" />
                              View
                            </button>

                            <button
                              type="button"
                              className="tb-refer-btn"
                              title="Refer booking"
                              onClick={() => openReferModal(service)}
                            >
                              <i className="fa fa-share-alt" />
                              Refer
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}

                  {currentServices.length === 0 && (
                    <tr>
                      <td colSpan="8">
                        <div className="tb-empty-state">
                          <div className="tb-empty-icon">
                            <i className="fa fa-flask" />
                          </div>
                          <h4>No test bookings found</h4>
                          <p>
                            Booked test records will appear here once available.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="tb-pagination">
              <span className="tb-pagination-info">
                Showing{" "}
                {Object.values(orders || {}).length === 0
                  ? 0
                  : indexOfFirst + 1}
                {" - "}
                {Math.min(
                  indexOfLast,
                  Object.values(orders || {}).length,
                )} of {Object.values(orders || {}).length} bookings
              </span>

              <div className="tb-pagination-controls">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="tb-page-btn"
                  type="button"
                >
                  <i className="fa fa-chevron-left" />
                  Prev
                </button>

                <span className="tb-page-number">
                  Page <strong>{currentPage}</strong> of{" "}
                  <strong>{totalPages || 1}</strong>
                </span>

                <button
                  disabled={currentPage >= totalPages || totalPages === 0}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="tb-page-btn"
                  type="button"
                >
                  Next
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* VIEW DETAILS MODAL */}
        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          centered
          size="lg"
          dialogClassName="tb-modal-dialog"
        >
          <div className="tb-modal">
            <div className="tb-modal-header">
              <div className="tb-modal-title-wrap">
                <div className="tb-modal-icon">
                  <i className="fa fa-file-text-o" />
                </div>

                <div>
                  <h4>Booking Details</h4>
                  <p>Complete information about this test booking.</p>
                </div>
              </div>

              <button
                type="button"
                className="tb-modal-close"
                onClick={() => setShowViewModal(false)}
              >
                ×
              </button>
            </div>

            <Modal.Body className="tb-modal-body">
              <div className="tb-profile-banner">
                <div className="tb-profile-avatar">
                  {patient?.patientName?.charAt(0) || "P"}
                </div>

                <div>
                  <h3>{patient?.patientName || "Patient"}</h3>
                  <p>
                    <i className="fa fa-phone" />
                    {patient?.patientPhone || "Phone not available"}
                  </p>
                </div>
              </div>

              <div className="tb-detail-section">
                <div className="tb-detail-section-title">
                  <span className="tb-detail-title-icon">
                    <i className="fa fa-user" />
                  </span>
                  Patient & Test Information
                </div>

                <div className="tb-detail-grid">
                  <div className="tb-detail-item">
                    <label>Patient Name</label>
                    <strong>{patient?.patientName || "—"}</strong>
                  </div>

                  <div className="tb-detail-item">
                    <label>Phone Number</label>
                    <strong>{patient?.patientPhone || "—"}</strong>
                  </div>

                  <div className="tb-detail-item">
                    <label>Test Name</label>
                    <strong>{patient?.serviceName || "—"}</strong>
                  </div>

                  <div className="tb-detail-item">
                    <label>Service Person</label>
                    <strong>
                      {patient?.servicePerson
                        ? `${patient.servicePerson.firstName || ""} ${
                            patient.servicePerson.lastName || ""
                          }`.trim()
                        : "Not assigned"}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="tb-detail-section">
                <div className="tb-detail-section-title">
                  <span className="tb-detail-title-icon">
                    <i className="fa fa-headphones" />
                  </span>
                  Audiometer Information
                </div>

                <div className="tb-detail-grid">
                  <div className="tb-detail-item">
                    <label>Company</label>
                    <strong>{patient?.audiometer?.companyName || "—"}</strong>
                  </div>

                  <div className="tb-detail-item">
                    <label>Model</label>
                    <strong>{patient?.audiometer?.model || "—"}</strong>
                  </div>

                  <div className="tb-detail-item">
                    <label>AC Headphone</label>
                    <strong>{patient?.audiometer?.acHeadPhone || "—"}</strong>
                  </div>
                </div>
              </div>

              <div className="tb-billing-panel">
                <div>
                  <span>Grand Total Amount</span>
                  <small>Booking billing information</small>
                </div>

                <strong>₹{patient?.bill?.grandTotalAmount ?? "—"}</strong>
              </div>
            </Modal.Body>

            <div className="tb-modal-footer">
              <Button
                className="tb-modal-secondary-btn"
                onClick={() => setShowViewModal(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </Modal>

        {/* REFER MODAL */}
        <Modal
          show={showReferModal}
          onHide={() => setShowReferModal(false)}
          centered
          size="md"
          dialogClassName="tb-modal-dialog"
        >
          <div className="tb-modal">
            <div className="tb-modal-header">
              <div className="tb-modal-title-wrap">
                <div className="tb-modal-icon">
                  <i className="fa fa-share-alt" />
                </div>

                <div>
                  <h4>Refer Booking</h4>
                  <p>Select a referral for this test booking.</p>
                </div>
              </div>

              <button
                type="button"
                className="tb-modal-close"
                onClick={() => setShowReferModal(false)}
              >
                ×
              </button>
            </div>

            <Modal.Body className="tb-modal-body">
              <div className="tb-refer-patient">
                <span className="tb-refer-patient-icon">
                  <i className="fa fa-user" />
                </span>

                <div>
                  <small>Booking for</small>
                  <strong>{patient?.patientName || "—"}</strong>
                  <span>{patient?.serviceName || "—"}</span>
                </div>
              </div>

              <div className="tb-referral-heading">
                <h5>Available Referrals</h5>
                <span>{referrals.length} Available</span>
              </div>

              {referrals.length > 0 ? (
                <div className="tb-referral-list">
                  {referrals.map((referral, index) => {
                    const isSelected = selectedReferrals.some(
                      (item) => item.id === referral.id,
                    );

                    const handleSelect = () => {
                      setSelectedReferrals((prev) => {
                        const alreadySelected = prev.some(
                          (item) => item.id === referral.id,
                        );

                        if (alreadySelected) {
                          return prev.filter((item) => item.id !== referral.id);
                        }

                        return [...prev, referral];
                      });

                      setReferralConfirmed(false);
                    };

                    return (
                      <div
                        key={referral.id || index}
                        className={`tb-referral-item ${
                          isSelected ? "tb-referral-selected" : ""
                        }`}
                        onClick={handleSelect}
                      >
                        <div className="tb-referral-avatar">
                          {referral.referalCommonUserName?.charAt(0) || "R"}
                        </div>

                        <div className="tb-referral-info">
                          <strong>{referral.referalCommonUserName}</strong>
                          <small>Referral ID: {referral.id}</small>
                          <small>District: {referral.district}</small>
                          <small>Type: {referral.referralType}</small>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "12px",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={{ flex: 1 }}>
                              <small>Commission Rate (%)</small>
                              <input
                                type="number"
                                min="0"
                                placeholder="Rate"
                                value={
                                  referralCommissions[referral.id]
                                    ?.commissionRate ?? ""
                                }
                                onChange={(e) =>
                                  setReferralCommissions((prev) => ({
                                    ...prev,
                                    [referral.id]: {
                                      ...prev[referral.id],
                                      commissionRate: e.target.value,
                                    },
                                  }))
                                }
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                  borderRadius: "7px",
                                  outline: "none",
                                }}
                              />
                            </div>

                            <div style={{ flex: 1 }}>
                              <small>Commission Amount (₹)</small>
                              <input
                                type="number"
                                min="0"
                                placeholder="Amount"
                                value={
                                  referralCommissions[referral.id]
                                    ?.commissionAmount ?? ""
                                }
                                onChange={(e) =>
                                  setReferralCommissions((prev) => ({
                                    ...prev,
                                    [referral.id]: {
                                      ...prev[referral.id],
                                      commissionAmount: e.target.value,
                                    },
                                  }))
                                }
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                  borderRadius: "7px",
                                  outline: "none",
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          className={`tb-select-referral-btn ${
                            isSelected ? "tb-selected-btn" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect();
                          }}
                        >
                          {isSelected ? "Selected ✓" : "Select"}
                        </button>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="tb-referral-empty">
                  <div>
                    <i className="fa fa-users" />
                  </div>
                  <h5>No referral list connected</h5>
                  <p>
                    Connect your referral-list API and its data fields to
                    display available referrals here.
                  </p>
                </div>
              )}

              {referralConfirmed && (
                <div className="tb-referral-confirmed">
                  <i className="fa fa-check-circle" />
                  Referral selected in this session. It has not been saved to
                  the server.
                </div>
              )}
            </Modal.Body>

            <div className="tb-modal-footer">
              <Button
                className="tb-modal-secondary-btn"
                onClick={() => setShowReferModal(false)}
              >
                Cancel
              </Button>

              <Button
                className="tb-modal-primary-btn"
                disabled={referralConfirmed}
                onClick={handleConfirmReferral}
              >
                {referralConfirmed ? "Selected" : "Confirm Selection"}
              </Button>
            </div>
          </div>
        </Modal>

        {/* Footer */}
        <div className="section-body tb-footer">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Testbooking;
